export default function getResource(label, vars = []) {
    const resources = {
        // Free returns banner
        freeReturnsBannerPrefix: 'Gratuit',
        freeReturnsBannerSuffix: ' Retours en magasin ou en ligne dans un délai de 30 jours*',
        freeReturnsInfoAriaLabel: 'Détails de la politique de retour',

        // Card labels (renamed per SHP-5111)
        freeShippingCardTitle: 'Expédition gratuite',
        fastDeliveryCardTitle: 'Livraison rapide',
        pickupCardTitle: 'Ramassage',

        // Card ETAs
        pickupCardEta: 'Dès aujourd’hui',
        fastDeliveryCardEta: 'Dès aujourd’hui',

        // Gift card overrides (SHP-5234) — English placeholder, pending SDL translation
        availableInAllStoresCardTitle: 'Available in All Stores',
        fastDeliveryNotAvailable: 'Not available for this item',
        pickupNotAvailable: 'Not available for pickup',

        // Shipping details panel
        shippingPanelTo: 'à',
        shippingPanelZipAriaLabel: 'Modifier l’emplacement de livraison',
        shippingPanelInfoAriaLabel: 'Détails de la politique d’expédition et de retour',
        shippingPanelBiPrefix: 'Les membres Beauty Insider profitent de l’ ',
        shippingPanelBiSuffix: 'expédition standard GRATUITE',

        // Auto-Replenish row
        autoReplenishRowSavePercent: `Économisez ${vars[0]}`,
        autoReplenishRowSuffix: ' avec le réapprovisionnement automatique',
        autoReplenishRowCheckboxAriaLabel: `Économisez ${vars[0]} avec le réapprovisionnement automatique`,

        // Auto-Replenish expanded details (SHP-5122)
        deliveryEvery: 'Deliver every:',
        mostCommon: 'most common',
        deliveryFrequencyLinkAriaLabel: 'Change Auto-Replenish delivery frequency',
        autoReplenishRowNotEligible: 'Not eligible for Auto-Replenish',
        autoReplenishLegalOptIn: 'By enrolling, you consent to the recurring charge for your subscription.',
        learnMore: 'Learn more',
        autoReplenishFirstTimeLegalShown: `*First-time subscribers get ${vars[0]} off their first ${vars[1]} orders, delivered within ${vars[2]} months of the initial order placement. Promo period ends ${vars[3]}.`,
        autoReplenishFirstTimeLegalDetails: 'Details',
        autoReplenishFirstTimeLegalMoreDetails: `For each Hot Deal item, subscription and quantity is limited to 1 per customer. After ${vars[0]} replenishment orders at ${vars[1]} off or after ${vars[2]} months of the initial sign-up date, whichever comes first, the subscription renews at ${vars[3]} off.`,

        // Radiogroup
        fulfillmentMethodsGroupAriaLabel: 'Choisir une méthode d’expédition'
    };

    return resources[label];
}
